import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem, MenuItem } from 'primeng/api';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { MembershipModel, MembershipModelFormChecker } from '../../../models/PatientAccount';
import { CountriesService } from '../../../services/countries.service';
import { PatientService } from '../../../services/patient.service';
import { ICustomWindow, WindowRefService } from 'src/app/services/window-ref.service';
import { MenuService } from '../shared/app.menu.service';
import { Title } from "@angular/platform-browser";
import { FinalTransaction } from 'src/app/models/transactions';
import { Basket } from 'src/app/models/basket';
import { client, dataCollector } from 'braintree-web';
import { create as dropin_create, paypalCreateOptions, Dropin, PaymentMethodPayload } from 'braintree-web-drop-in';
import { DaterenderService } from '../../../services/daterender.service';
import { ApiResult } from '../../../models/PromiseResult';
import { CanComponentLeave } from 'src/app/guards/un-saved-changes.guard';
import { invoice } from 'src/app/models/invoice';
import { name_input, address, city, zipCode, phoneNumber, DOCUMENT_SUPPORTED_TYPES, IMAGE_PROFILE_ID_SUPPORTED_TYPES, RESUME_SUPPORTED_TYPES } from "./../../../constant/constant"
import { TraceClassDecorator } from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-activate-membership',
    templateUrl: './activate-membership.component.html',
    styleUrls: ['./activate-membership.component.css'
        , '../../../../assets/css/custom-egd.css'
    ]
})
@TraceClassDecorator()
export class ActivateMembershipComponent implements OnInit, CanComponentLeave {

    // n :FormControl=new FormControl();
    Fu: boolean = false;
    sc: boolean = false;
    logo_url: string = "";
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;



    membershipFormChecker: MembershipModelFormChecker;

    country: any;

    filteredCountries: any[];


    agree: boolean;


    radioValue: string;


    dialogVisible: boolean;



    menuItems: MenuItem[];

    panelMenuItems: MenuItem[];


    responsiveOptions;

    maskValue: string;

    model: any[];

    toggleButtonChecked: boolean;

    selectedType: string;

    phone: any = []

    unformattedStates: any[];

    countries: any = [];

    states: any[];

    selectedCountry = null;

    selectedCity;

    patient: MembershipModel;

    selectedPhoneCode_primary: string = "";

    selectedPhoneCode_secondary: string = "";

    statesInput: boolean = true;

    statesInputDisabled: boolean = true;

    selectedState = null;

    selectedRelation = null;

    relations;

    unique_id: SelectItem[] = [];

    // result;

    // isSuccess;

    medical_record_number;

    userid;

    temp;
    patient_guid: any;
    is_india: boolean;
    private _window: ICustomWindow;
    public rzp: any;
    private key: string = "";
    public options: any = {};
    payment_token: any;
    transaction: FinalTransaction;
    transaction_id: any;
    transaction_no: number = 0;
    // posting: boolean;
    // response: PromiseResult;
    // serverError: ServerError;



    firstName = "";

    middleName = "";

    lastName = "";

    dateBirth: string = null;

    country_id: Number = null;

    optionSelect: boolean = false

    selfActivated: boolean = true;

    display: boolean = false;
    display1: boolean = false;

    dateTime = new Date();

    primary_contact_number: string = "";
    secondary_contact_number: string = "";
    choice_selection_disabled: boolean = true;

    masterForm_Checker: boolean = false;
    nopaymentselected: boolean;
    display3: boolean = false;
    purl: string = "";
    data: invoice;
    displayModal: boolean = false;
    showInvoice: string = "showInvoice";
    printContent: string = "print-content";
    provider_id: string = "";
    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    api_result: ApiResult = new ApiResult(false);
    slug: string = "";
    max_date = this.utilitiesService.getMaxDate();

    constructor(
        private readonly router: Router,
        private readonly countryService: CountriesService,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly zone: NgZone,
        private readonly winRef: WindowRefService,
        private readonly patientservice: PatientService,
        private readonly menuService: MenuService,
        private readonly titleService: Title,
        private readonly daterenderService: DaterenderService,
        private readonly providerStateService: ProviderStateService,
        private readonly utilitiesService: UtilitiesService) {

        this._window = this.winRef.nativeWindow;
        this.nopaymentselected = false;

    }
    canLeave(): boolean {
        if (this.Fu || this.sc) {
            return window.confirm('Are You Sure  You Want To Leave This Page?');
        }
        return true;

        //return window.confirm('Are You Sure You Want To Leave This Page?');
    };
    notdirty() {
        this.sc = false;

    }
    dirty() {
        this.sc = true;
    }
    @ViewChild(NgForm) membershipform: NgForm;
    async ngOnInit() {
        this.provider_id = this.providerStateService.getProviderId();
        this.slug = this.providerStateService.getProviderSlug();
        this.logo_url = this.providerStateService.getLogoUrl();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
            { label: 'Add Members' },
            // { label: ' ',routerLink: ['/patient/activateaccountwelcome'] },
        ]);
        this.api_result = new ApiResult(false);
        this.SetTitle("Dashboard - Add Members");
        this.optionSelect = false;
        this.dateTime.setDate(this.dateTime.getDate());
        this.userid = sessionStorage.getItem('userid');
        await this.GetUserDetails();

        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];
        this.relations = [
            { name: "Father" },
            { name: "Mother" },
            { name: "Brother" },
            { name: "Sister" },
            { name: "Spouse" },
            { name: "Son" },
            { name: "Daughter" }
        ];

        this.unique_id = [
            { label: "Driving License", value: "Driving License" },
            { label: "Passport", value: "Passport" },
            { label: "Other Govt. ID", value: "Other Govt. ID" }
        ];
        // this.unique_id=[{name:"Driving License"},{name:"Passport"},{name:"Other Govt. ID"},];


        await this.resetForm();

        await this.resetFormChecker();

        await this.getCountries();

        //    await this.GetUserDetails()
        if (this.membershipform != null)
            this.membershipform.statusChanges.subscribe(() => {
                this.Fu = this.membershipform.dirty;
            })


    }

    async resetFormChecker() {
        this.membershipFormChecker = {
            user_guid: true,
            first_name: true,
            middle_name: true,
            last_name: true,
            file: true,
            relation: true,
            gender: true,
            date_of_birth: true,
            country_id: true,
            state_name: true,
            state_id: true,
            city: true,
            address_line_1: true,
            address_line_2: true,
            zip_code: true,
            primary_contact_number: true,
            secondary_contact_number: true,
            identification_type: true,
            identification: true,
        }
        this.masterForm_Checker = false;

    }

    async resetForm() {
        this.patient = {
            user_guid: this.userid,
            first_name: "",
            middle_name: "",
            last_name: "",
            file: null,
            relation: "",
            gender: "",
            date_of_birth: null,
            country_id: "",
            state_name: "",
            state_id: null,
            city: "",
            address_line_1: "",
            address_line_2: "",
            zip_code: "",
            primary_contact_number: "",
            secondary_contact_number: "",
            identification_type: null,
            identification: null,
        }

        this.selectedCountry = null;
        this.statesInput = true;
        this.statesInputDisabled = true;
        this.selectedPhoneCode_primary = "";
        this.selectedPhoneCode_secondary = "";
        this.selectedState = null;
        this.patient_date_of_birth = null;

    }

    async GetUserDetails() {
        this.api_result = new ApiResult(false);
        this.api_result.Posting = true;
        await this.patientservice.GetMyMembershipDetailsData(this.userid).toPromise().then(result => {
            this.api_result.PromiseResult = result;
            if (result.success) {
                this.firstName = result.data.user.first_name;
                this.middleName = (result.data.user.middle_name == null ? '' : result.data.user.middle_name);
                this.lastName = result.data.user.last_name;
                //this.patient_date_of_birth = new Date(result.data.user.date_of_birth);
                this.dateBirth = this.daterenderService.render_data(new Date(result.data.user.date_of_birth.replace(/-/g, '/')));
                this.country_id = Number(result.data.user.country_id);
                this.selfActivated = result.data.Activated;
                this.choice_selection_disabled = false;
            }
            this.api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.api_result.ServerError = error.error;
            this.api_result.PromiseResult.success = false;
            this.api_result.Posting = false;
        });
    }

    showInvoiceDialog() {
        this.display = true;
        //window.print();
        //this.display = false;
    }


    private readonly image: string = "https://eglobalblobdev.blob.core.windows.net/assets/logo/logo2.png";
    basket: Basket;
    payment_id: string;
    patient_date_of_birth: Date = null;

    async patientAccountSubmission(): Promise<void> {
        this.api_result = new ApiResult(false);
        this.api_result.Posting = true;
        this.is_paypal = null;
        this.patient.country_id = this.selectedCountry.id;
        if (this.agree == true) {
            this.patient.relation = this.selectedRelation.name;
        }
        if (this.statesInput == true) {
            this.patient.state_name = this.selectedState;
        }
        else if (this.statesInput == false) {
            this.patient.state_name = this.selectedState.name;
            this.patient.state_id = this.selectedState.id;
        }
        if (Boolean(this.primary_contact_number) && this.primary_contact_number.length > 0) {
            this.patient.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
        }
        else if (!Boolean(this.primary_contact_number)) {
            this.patient.primary_contact_number = '+' + this.selectedPhoneCode_primary
        }
        if (Boolean(this.secondary_contact_number) && this.secondary_contact_number.length > 0) {
            this.patient.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
        }
        else if (!Boolean(this.patient.secondary_contact_number)) {
            this.patient.secondary_contact_number = "";
        }
        if (this.agree == false) this.patient.relation = "self";

        let form: FormData = new FormData();
        this.patient.date_of_birth = this.daterenderService.render_data(this.patient_date_of_birth);

        form.set("user_guid", this.patient.user_guid);
        form.set("file", this.patient.file);
        form.set("first_name", this.patient.first_name);
        form.set("middle_name", this.patient.middle_name);
        form.set("last_name", this.patient.last_name);
        form.set("relation", this.patient.relation);
        form.set("gender", this.patient.gender);
        form.set("date_of_birth", this.patient.date_of_birth);
        form.set("country_id", this.patient.country_id);
        form.set("state_name", this.patient.state_name);
        form.set("state_id", this.patient.state_id.toString());
        form.set("city", this.patient.city);
        form.set("address_line_1", this.patient.address_line_1);
        form.set("address_line_2", this.patient.address_line_2);
        form.set("zip_code", this.patient.zip_code);
        form.set("address_line_1", this.patient.address_line_1);
        form.set("address_line_2", this.patient.address_line_2);
        form.set("zip_code", this.patient.zip_code);
        form.set("primary_contact_number", this.patient.primary_contact_number);
        if (Boolean(this.patient.secondary_contact_number))
            form.set("secondary_contact_number", this.patient.secondary_contact_number);
        if (this.patient.identification_type != null && this.patient.identification != null) {
            form.set("identification_type", this.patient.identification_type);
            form.set("identification", this.patient.identification);
        }

        await this.patientservice.createUserFree(form).toPromise().then(async result => {
            this.api_result.PromiseResult = result;
            if (result.success) {
                // const order:order_model=result.data;
                // this.basket = order.basket;
                // if(order.basket.payment_method==payment_method.razorpay)
                //     this.key=order.payment_gateway_id.razor_pay_id;
                // this.payment_id = order.payment_id;
                // this.transaction_id = order.transaction_id;
                // this.currency = this.basket.currency_type;
                // await this.submitData();
                // this.setMenuItems();
                this.medical_record_number = result.data.medical_record_number;
                this.success = true;
                this.final_result = true;
                this.display1 = true;
            }

            this.api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.api_result.ServerError = error.error;
            this.api_result.PromiseResult.success = false;
            this.api_result.Posting = false;
        });

    }

    fileu: boolean = false;
    uploadFiles(file: File[]) {


        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                this.patient.file = null;
            }
            else if (file[0].size < 5033165) {
                this.patient.file = file[0];
            }
        }
        else {
            this.patient.file = null;
        }

    }
    async paybyrazor() {
        this.rzp = new this.winRef.nativeWindow["Razorpay"](this.options);
        this.rzp.open();
    }
    // disablefile: boolean= false;
    // disabledfile()
    // {
    //     if(this.patient.file.size > 5033165)
    //     {
    //        this.patient.identification=null;  
    //        this.patient.file=null;
    //     }
    //     this.disablefile= true;
    // }
    fileList = [];
    async uploadUniqueIDFiles(file: File[]) {


        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                this.patient.identification = null;
            }
            else if (file[0].size < 5033165) {
                this.patient.identification = file[0];
            }
        }
        else {
            this.patient.identification = null;
        }
    }
    // onHide() {
    //     this.fileu = false;
    // }
    resetUnquieIDUpload() {
        this.patient.identification = null;
    }

    resetUpload() {
        this.patient.file = null;
    }


    processing: boolean = false;
    final_result: boolean = false;
    amount: any;
    currency: string;
    priority_type_id: number = -1;
    error: string = null;
    success: boolean = null;
    view_payment: boolean = false;
    saving: boolean = false;
    invoice_id: string = null;


    private async initPay(): Promise<void> {
        this.options = {
            key: this.key, // add razorpay key here
            name: '',
            description: this.basket.order_name,
            order_id: this.payment_id,
            image: this.image, // razorpay takes amount in paisa
            prefill:
            {
                name: '',
                //email: sessionStorage.getItem('email'), // add your email id
            },
            notes: {},
            theme:
            {
                color: '#3880FF'
            },
            handler: await this.paymentHandler.bind(this),
            modal: {
                ondismiss: (() => {
                    this.zone.run(() => {
                        // add current page routing if payment fails
                        this.view_payment = false;
                        this.success = false;
                    })
                })
            }
        }
        this.options.name = this.patient.first_name + " " + this.patient.last_name;

        this.options.amount = this.amount * 100;
        //this.rzp = new this.winRef.nativeWindow['Razorpay'](this.options);
        // this.rzp.open();
    }

    private paymentHandler(res: any) {
        this.zone.run(() => {
            // add API call here

            this.payment_token = res.razorpay_payment_id;
            if (this.payment_token.length > 0) {
                this.SubmitTransaction("razorpay");
            }
        });
    }

    private async submitData(): Promise<void> {


        this.success = null;
        this.saving = true;


        if (this.basket.payment_method == "razorpay") {
            await this.razorpay();
            this.is_paypal = false;
        }
        else {
            this.is_paypal = true;
            await this.paypal();
        }

    }

    private async razorpay() {
        this.view_payment = true;
        await this.initPay();
    }
    nonce: string = ""
    deviceData: any = null;
    dropinInstance: Dropin;
    paypal_obj: paypalCreateOptions = {
        flow: 'checkout',
        amount: 0,
        currency: ""
    }
    is_paypal: boolean = false;

    private async BrainTreeCreate(clienttoken: string) {
        //let drop_mod:HTMLElement=document.getElementById('dropin-mod');
        //drop_mod.style.display="block";
        //let drop:HTMLElement=document.getElementById('dropin-container');
        //drop.style.display="block";
        this.is_paypal = true;

        await dropin_create(
            {
                authorization: clienttoken,
                container: '#dropin-container',
                //card:true,
                paypal: this.paypal_obj
            }
        ).then(async dropinInstance => {
            this.dropinInstance = dropinInstance;


        }).catch(error => {

        })
    }

    async pay() {

        this.api_result = new ApiResult(false);
        this.api_result.Posting = true;
        this.nopaymentselected = false;

        await this.dropinInstance.requestPaymentMethod().then(async payload => {
            this.nonce = payload.nonce;
            this.payment_token = this.nonce;

            await this.DeviceData(this.payment_id);
        }).catch(error => {

            if (error.message == "No payment method is available.") {
                this.nopaymentselected = true;
            }
        })
    }

    private async DeviceData(clienttoken: string) {
        await client.create(
            {
                authorization: clienttoken
            }
        ).then(async clientInstance => {
            await dataCollector.create(
                {
                    client: clientInstance,
                    paypal: true
                }
            ).then(async dataCollectorInstance => {

                this.deviceData = dataCollectorInstance.deviceData;
                await this.SubmitTransaction("paypal");
            }).catch(async error => {

                await this.SubmitTransaction("paypal");

            })
        }).catch(async error => {

            await this.SubmitTransaction("paypal");

        })
    }



    private async paypal() {
        //this.amount = await this.getamount();
        this.paypal_obj.currency = this.basket.currency_type;
        this.paypal_obj.amount = this.basket.raw_total;
        this.view_payment = true;

        await this.BrainTreeCreate(this.payment_id);

        //await this.DeviceData(this.payment_id);
        //await this.SubmitTransaction("paypal");
    }






    private async SubmitTransaction(payment_method: string): Promise<void> {
        this.view_payment = false;
        this.processing = true;

        this.transaction = {
            patient_guid: this.basket.patient_guid,
            deviceData: this.deviceData,
            payment_method: payment_method,
            payment_token: this.payment_token,
            transaction_id: this.transaction_id
        };
        await this.patientservice.SubmitPaymentToken(this.transaction).toPromise().then(result => {

            if (!result.success) {
                this.success = false;
                this.error = result.error.message;
            }
            else {
                this.success = true;
                this.final_result = true;
                // this.setMenuItems();
                this.medical_record_number = result.data.medical_record_number;
                this.invoice_id = result.data.invoice_id;
                this.transaction_no = result.data.transaction_no;
                this.display1 = true;
                this.processing = null;
                this.purl = result.data.invoice_url;
            }
            this.saving = false;
        })
    }

    async formChecker() {
        ///
        // Use ngModel Varibles For  
        ///

        for (let i = 0; i < Object.keys(this.membershipFormChecker).length; i++) {

            // if (obj.hasOwnProperty(Object.keys(this.membershipFormChecker)[i])) 
            // {

            if (Object.keys(this.membershipFormChecker)[i] == 'user_guid') {

                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;
            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'relation') {
                if (this.agree) { //Membership for others
                    if (this.selectedRelation == null)
                        this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                    else if (this.selectedRelation != null)
                        this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;
                }
            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'first_name') {
                if (this.patient.first_name.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.first_name.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;
            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'middle_name') {
                // if(this.patient.first_name.length==0)
                // this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]]=false;
                // else if(this.patient.first_name.length>0)
                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'last_name') {
                if (this.patient.last_name.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.last_name.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'date_of_birth') {

                if (this.patient_date_of_birth == null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient_date_of_birth != null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'file') {
                // if(this.patient.file==null)
                // this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]]=false;
                // else if(this.patient.file!=null)
                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            // else if(Object.keys(this.membershipFormChecker)[i]=='relation'){

            // }
            else if (Object.keys(this.membershipFormChecker)[i] == 'gender') {
                if (this.patient.gender.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.gender.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'country_id') {
                if (this.selectedCountry == null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.selectedCountry != null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'state_name') {
                if (this.selectedState == null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.selectedState != null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'state_id') {
                if (this.selectedState == null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.selectedState != null)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'city') {
                if (this.patient.city.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.city.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'zip_code') {
                if (this.patient.zip_code.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.zip_code.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'address_line_1') {
                if (this.patient.address_line_1.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.patient.address_line_1.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'address_line_2') {
                // if(this.patient.address_line_2.length==0)
                // this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]]=false;
                // else if(this.patient.address_line_2.length>0)
                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'primary_contact_number') {
                if (this.primary_contact_number.length == 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = false;
                else if (this.primary_contact_number.length > 0)
                    this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'secondary_contact_number') {
                // if(this.secondary_contact_number.length==0)
                // this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]]=false;
                // else if(this.secondary_contact_number.length>0)
                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;
            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'identification_type') {

                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            else if (Object.keys(this.membershipFormChecker)[i] == 'identification') {

                this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] = true;

            }
            // }
        }

        await this.checkFieldsFilled()
        if (this.masterForm_Checker) {

            await this.patientAccountSubmission()
        }
        // patientAccountSubmission()
    }
    omit_special_char(event) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    checkFieldsFilled() {
        this.masterForm_Checker = true;

        for (let i = 0; i < Object.keys(this.membershipFormChecker).length; i++) {
            if (this.membershipFormChecker[Object.keys(this.membershipFormChecker)[i]] == false)
                this.masterForm_Checker = false;
        }


    }
    canceld() {
        this.router.navigate(['/' + this.slug + '/patient/dashboard']);
    }


    private setMenuItems() {
        this.menuService.setItems([
            {
                label: 'Patient Dashboard', icon: 'fa fa-fw fa-bar-chart',
                routerLink: ['/patient/dashboard'], disabled: false
            },
            {
                label: 'Consult Doctor', icon: 'fa fa-fw fa-user-md',
                routerLink: ['/patient/consultdoctor'], disabled: false,
            },
            {
                label: 'Packages', icon: 'fa fa-fw fa-user-plus',
                routerLink: ['/patient/packages'],
            },
            {
                label: 'Upload Medical Details', icon: 'fa fa-fw fa-upload',
                routerLink: ['/patient/uploadandeditdocuments'], disabled: false
            },
            {
                label: 'Track Request', icon: 'fa fa-fw fa-address-card',
                routerLink: ['/patient/trackrequest'], disabled: false
            },
            {
                label: 'Message Center', icon: 'fa fa-fw fa-envelope-open-o',
                routerLink: ['/patient/messagecenter'], disabled: false
            },
            {
                label: 'View Health Summary', icon: 'pi pi-copy',
                routerLink: ['/patient/viewhealth'], disabled: false
            },
            {
                label: 'Doctor Reports', icon: 'fa fa-fw fa-list-alt',
                routerLink: ['/patient/doctorreports'], disabled: false
            },
            {
                label: 'Add New Members', icon: 'fa fa-fw fa-user-plus',
                routerLink: ['/patient/members/add'],
            },

            {
                label: 'Transactions', icon: 'fa fa-fw fa-credit-card',
                routerLink: ['/patient/transactions'], disabled: false
            },

            // {label: 'Help', icon: 'fa fa-fw fa-info-circle', routerLink: ['/documentation']},
            {
                label: 'Sign Out', icon: 'fa fa-fw fa-power-off',
                routerLink: ['/logout']
            }
        ]);
    }


    async UserDetails() {
        // membershipform.form.reset();
        this.optionSelect = true
        if (!this.agree) {
            await this.resetFormChecker();
            await this.resetForm();
            this.patient.first_name = this.firstName[0].toUpperCase() + this.firstName.slice(1);
            if (this.middleName.length > 0) this.patient.middle_name = this.middleName[0].toUpperCase() + this.middleName.slice(1);
            this.patient.last_name = this.lastName[0].toUpperCase() + this.lastName.slice(1);
            this.patient_date_of_birth = new Date(this.dateBirth);
            //this.patient.date_of_birth=this.daterenderService.render_data(this.patient.date_of_birth);

            for (let i = 0; i < this.countries.length; i++) {
                if (this.country_id == Number(this.countries[i].id)) {

                    this.selectedCountry = this.countries[i];

                }


            }
            this.changeStates();
            this.selectedRelation = "";
            this.sc = true;

        }
        else if (this.agree) {
            await this.resetFormChecker();
            await this.resetForm();

        }

    }


    private async getCountries() {
        this.api_result = new ApiResult(false);
        this.api_result.Posting = true;
        await this.countryService.getCountries(this.provider_id).toPromise().then((countries) => {
            this.countries = countries;
            this.api_result.Posting = false;
        });


    }

    private async getStates(country_id: number) {
        this.api_result = new ApiResult(false);
        this.api_result.Posting = true;
        await this.countryService.getStates(country_id).toPromise().then((states) => {
            this.unformattedStates = states;
            this.api_result.Posting = false;
        });

    }

    async changeStates() {

        this.unformattedStates = [];
        this.states = [];
        this.temp = []
        this.phone = [];
        this.selectedState = null;
        // this.getStates(this.selectedCountry.id);
        await this.getStates(this.selectedCountry.id);


        if (this.unformattedStates.length > 0) {
            this.statesInput = false;

            for (let i = 0; i < this.unformattedStates.length; i++) {
                this.temp.push({ name: this.unformattedStates[i].state_name, id: this.unformattedStates[i].id });
            }
            this.states = this.temp;


        }
        else {
            this.statesInput = true;
            this.statesInputDisabled = false;
        }

        this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
        this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;




    }

    searchCountry(query, countries: any[]): any[] {
        // in a real application, make a request to a remote url with the query and return filtered results,
        // for demo we filter at client side
        const filtered: any[] = [];
        for (const item of countries) {
            const country = item;
            if (country.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(country);
            }
        }
        return filtered;
    }

    clickfn() {
        this.agree = !this.agree;
    }

    print() {
        window.print();
    }

    SetTitle(title: string) {
        // let Title=this.titleService.getTitle().split(" ");
        // let notif=Title[0].substr(1,Title[0].length-2);
        this.titleService.setTitle(title);

    }

}
